import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { getGuestUserState } from 'modules/selectors/guestUser';
import loader from 'assets/img/landing/loader.svg';
import { rotation } from 'components/keyFrames';
import { verifyCode, verifyCodeFailed } from 'modules/actions/guestUser';

const Wrapper = styled.div`
	padding: 30px 120px 60px;
	@media(max-width: 1000px) {
	    padding: 30px 10px;
	    width: 100%;
	}
`;

const Title = styled.div`
	font-size: 32px;
	color: #FEC600;
	line-height: 42px;
	font-family: 'ImpactBold', sans-serif;
	text-transform: uppercase;
	text-align: center;
	margin-bottom: 10px;
`;
const SubTitle = styled.div`
	font-size: 12px;
	color: #fff;
	line-height: 20px;
	font-family: 'EundBold', sans-serif;
	text-align: center;
	margin-bottom: 40px;
`;

const Code = styled.div`
	width: 89px;
	height: 50px;
	background: #EDECE8;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0;
	font-family: 'EundBold', sans-serif;
`;
const Input = styled.input`
	height: 48px;
	border: 1px solid #EDECE8;
	padding: 0 13px;
	font-size: 16px;
	font-family: 'EundBold', sans-serif;
	min-width: 300px;
	@media(max-width: 1000px) {
			min-width: auto;
			flex: 1;
		}
`;
const InputWrapper = styled.form<{ isError: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	${ props => props.isError && ErrorStyles };
	@media(max-width: 1000px) {
	    flex-direction: column;
	    justify-content: center;
	    align-items: center;
	}
`;
const InputWrapperInner = styled.div`
	display: flex;
	align-items: center;
	position: relative;
	@media(max-width: 1000px) {
		width: 100%;
		margin-bottom: 20px;
	}
`;

const ErrorStyles = css`
	${ Code } {
		background: #C3470E;
		color: #ffffff;
	}
	${ Input } {
		border-color: #C3470E;
		color: #C3470E;
	}
`;

const ButtonSection = styled.div`
	margin-left: 20px;
	@media(max-width: 1000px) {
		width: 100%;
		margin: 0;
	}
`;
const Button = styled.button`
	width: 140px;
	height: 50px;
	background: #FEC600;
	border-radius: 2px;
	font-family: 'ImpactBold', sans-serif;
	border: none;
	font-size: 30px;
	color: #362E2C;
	&:disabled {
		background: #E3E1DB;
		opacity: .2;
	}
	@media(max-width: 1000px) {
		width: 100%;
	}
`;

const Loader = styled.img`
    width: 100px;
    margin: 0 auto;
    display: block;
	animation: ${ rotation } 2s linear infinite;
`;
const Error = styled.div`
	position: absolute;
	width: 100%;
	color: #C3470E;
	text-align: center;
	font-family: EundBold, sans-serif;
	font-size: 16px;
	@media(max-width: 1000px) {
		top: -25px;
	}
`;

export const CodeEnterSection = () => {
	const dispatch = useDispatch();
	const { showLoader, error } = useSelector( getGuestUserState );
	const [value, setValue] = useState( '' )

	const submitPhone = ( e: React.FormEvent ) => {
		e.preventDefault();
		dispatch( verifyCode( value ) );
	}

	const changePhoneHandler = ( e: React.BaseSyntheticEvent ) => {
		const inputValue = e.currentTarget.value;
		dispatch( verifyCodeFailed( '' ) );
		setValue( inputValue );
	}
	const isButtonDisabled = !!error || value.length < 6;
	return (
		<Wrapper>
			<Title>Awesome, we have sent you a code</Title>
			<SubTitle>Enter it below and hit confirm.</SubTitle>
			{ !showLoader ? <InputWrapper onSubmit={ submitPhone } isError={ !!error }>
				<InputWrapperInner>
					<Code>CODE</Code>
					<Input
						type={ 'text' }
						placeholder={ 'Enter your code' }
						value={ value }
						onChange={ changePhoneHandler }
						inputMode={ 'numeric' }
						pattern={ '[0-9]*' }
						autoComplete={ 'one-time-code' }
					/>
					{error ? <Error>{ error }</Error> : null }
				</InputWrapperInner>
				<ButtonSection>
					<Button disabled={ isButtonDisabled }>CONFIRM</Button>
				</ButtonSection>
			</InputWrapper> : <Loader src={ loader } role={ 'presentation' }/> }
		</Wrapper>
	);
}
